import {CALL_API} from 'middleware/api';

import * as ActionTypes from '../BigStakeRequest';

function fetchCancelBigStakeRequest(data) {
    const {betId, stakeId} = data;
    return {
        type: ActionTypes.CANCEL_BIG_STAKE_REQUEST,
        [CALL_API]: {
            endpoint: `/api/bet/${betId}/big-stake/${stakeId}/cancel`,
            method: 'post',
            types: [ActionTypes.SUCCESS_BIG_STAKE_REQUEST_CANCEL, ActionTypes.FAILURE_BIG_STAKE_REQUEST_CANCEL],
            credentials: true,
            data
        }
    };
}

export function cancelBigStakeRequest(data) {
    return (dispatch) => {
        return dispatch(fetchCancelBigStakeRequest(data));
    };
}



// WEBPACK FOOTER //
// ./js/actions/creators/BigStakeRequest.js